/* tslint:disable */
/* eslint-disable */
/* @relayHash 80bfcea705abb8a17bd345727961eb70 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardPage_viewerQueryVariables = {};
export type DashboardPage_viewerQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly id: string;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"NavHeader_viewer" | "PageLoading_viewer" | "DashboardFeed_viewer" | "DashboardLayout_viewer">;
    } | null;
};
export type DashboardPage_viewerQuery = {
    readonly response: DashboardPage_viewerQueryResponse;
    readonly variables: DashboardPage_viewerQueryVariables;
};



/*
query DashboardPage_viewerQuery {
  viewer {
    ...NavHeader_viewer
    ...PageLoading_viewer
    ...DashboardFeed_viewer
    ...DashboardLayout_viewer
    user {
      id
    }
  }
}

fragment DashboardFeed_viewer on Viewer {
  ...FeedItem_viewer
  activityFeed(first: 25) {
    edges {
      node {
        id
        __typename
        ... on StudyRecord {
          completedAt
        }
        ...FeedItem_activityFeedItem
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment DashboardLayout_viewer on Viewer {
  user {
    id
    isAdmin
    accountType
    isUpgradedTeacher
    classroomMemberships {
      level
      classroom {
        id
        title
        identifier
      }
      id
    }
  }
}

fragment FeedItem_activityFeedItem on ActivityFeedItem {
  __typename
  ... on Worksheet {
    ...Worksheet_worksheet
    exercises {
      __typename
      id
    }
    creator {
      id
    }
  }
  ... on StudyRecord {
    ...StudyRecord_studyRecord
  }
}

fragment FeedItem_viewer on Viewer {
  user {
    id
  }
}

fragment FeedbackModal_viewer on Viewer {
  user {
    id
  }
}

fragment NavHeader_viewer on Viewer {
  ...FeedbackModal_viewer
  user {
    id
    username
    isAdmin
    createdAt
    isUpgradedTeacher
    accountType
    classroomMemberships {
      level
      classroom {
        id
        title
        identifier
      }
      id
    }
    worksheets(first: 1) {
      edges {
        node {
          id
        }
      }
    }
  }
}

fragment PageLoading_viewer on Viewer {
  ...NavHeader_viewer
}

fragment StudyRecord_studyRecord on StudyRecord {
  createdAt
  completedAt
  identifier
  score
  duration
  user {
    username
    id
  }
  worksheet {
    identifier
    title
    id
  }
}

fragment Worksheet_worksheet on Worksheet {
  title
  description
  identifier
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "createdAt",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "identifier",
  "args": null,
  "storageKey": null
},
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  }
],
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DashboardPage_viewerQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": (v1/*: any*/)
          },
          {
            "kind": "FragmentSpread",
            "name": "NavHeader_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "PageLoading_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DashboardFeed_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DashboardLayout_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DashboardPage_viewerQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isAdmin",
                "args": null,
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isUpgradedTeacher",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "classroomMemberships",
                "storageKey": null,
                "args": null,
                "concreteType": "ClassroomMembership",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "level",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "classroom",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Classroom",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  },
                  (v0/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "worksheets",
                "storageKey": "worksheets(first:1)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "WorksheetConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorksheetEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Worksheet",
                        "plural": false,
                        "selections": (v1/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "activityFeed",
            "storageKey": "activityFeed(first:25)",
            "args": (v6/*: any*/),
            "concreteType": "ActivityFeedItemConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ActivityFeedItemEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "type": "StudyRecord",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "completedAt",
                            "args": null,
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "score",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "duration",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v0/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "worksheet",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Worksheet",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v4/*: any*/),
                              (v0/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "Worksheet",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "description",
                            "args": null,
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "exercises",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v0/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "creator",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "User",
                            "plural": false,
                            "selections": (v1/*: any*/)
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "activityFeed",
            "args": (v6/*: any*/),
            "handle": "connection",
            "key": "DashboardFeed_activityFeed",
            "filters": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "DashboardPage_viewerQuery",
    "id": null,
    "text": "query DashboardPage_viewerQuery {\n  viewer {\n    ...NavHeader_viewer\n    ...PageLoading_viewer\n    ...DashboardFeed_viewer\n    ...DashboardLayout_viewer\n    user {\n      id\n    }\n  }\n}\n\nfragment DashboardFeed_viewer on Viewer {\n  ...FeedItem_viewer\n  activityFeed(first: 25) {\n    edges {\n      node {\n        id\n        __typename\n        ... on StudyRecord {\n          completedAt\n        }\n        ...FeedItem_activityFeedItem\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DashboardLayout_viewer on Viewer {\n  user {\n    id\n    isAdmin\n    accountType\n    isUpgradedTeacher\n    classroomMemberships {\n      level\n      classroom {\n        id\n        title\n        identifier\n      }\n      id\n    }\n  }\n}\n\nfragment FeedItem_activityFeedItem on ActivityFeedItem {\n  __typename\n  ... on Worksheet {\n    ...Worksheet_worksheet\n    exercises {\n      __typename\n      id\n    }\n    creator {\n      id\n    }\n  }\n  ... on StudyRecord {\n    ...StudyRecord_studyRecord\n  }\n}\n\nfragment FeedItem_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment FeedbackModal_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment NavHeader_viewer on Viewer {\n  ...FeedbackModal_viewer\n  user {\n    id\n    username\n    isAdmin\n    createdAt\n    isUpgradedTeacher\n    accountType\n    classroomMemberships {\n      level\n      classroom {\n        id\n        title\n        identifier\n      }\n      id\n    }\n    worksheets(first: 1) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment PageLoading_viewer on Viewer {\n  ...NavHeader_viewer\n}\n\nfragment StudyRecord_studyRecord on StudyRecord {\n  createdAt\n  completedAt\n  identifier\n  score\n  duration\n  user {\n    username\n    id\n  }\n  worksheet {\n    identifier\n    title\n    id\n  }\n}\n\nfragment Worksheet_worksheet on Worksheet {\n  title\n  description\n  identifier\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '2c4c2b57ae681bc6333a1e958ea80f9f';
export default node;
